import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, EXPORT_FILE_NAME } from './constants';

class TimeClockingProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async GetTechnicianList(Ids: any) {
		return this.fetch('/DropdownList/GetTechnicianListByWorkshopId/', { workshopId: Ids });
	}

	async GetTimeClockingReport(Parameters: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetTimeClockingReport/?${Parameters}`, EXPORT_FILE_NAME);
	}
}
export const apiProvider = new TimeClockingProvider();
